import http from './public'

// 获取协议
export const userAgree = (params) => {
  return http.fetchGet('/common/agree', params)
}

// 用户信息
export const userInfo = (params) => {
  return http.fetchGet('/user/checkLogin', params)
}

// 登陆
export const userLogin = (params) => {
  return http.fetchPost('/user/login', params)
}

// 注册账号
export const register = (params) => {
  return http.fetchPost('/user/register', params)
}

//修改密码
export const resetPassword = (params) => {
  return http.fetchPost('/user/resetPassword', params)
}

// 退出登陆
export const loginOut = (params) => {
  return http.fetchGet('/user/loginOut', params)
}

// 上传图片
export const upload = (params) => {
  return http.fetchPost('/user/imgaeUpload', params)
}
// 修改头像
export const updateheadimage = (params) => {
  return http.fetchPost('/user/updateheadimage', params)
}
// 捐赠列表
export const thanksList = (params) => {
  return http.fetchGet('/user/thanks', params)
}
// 首页接口
export const productHome = (params) => {
  return http.fetchGet('/goods/home', params)
}
// 首页接口
export const navList = (params) => {
  return http.fetchGet('/goods/navList', params)
}
// 推荐板块
export const recommend = (params) => {
  return http.fetchGet('/goods/recommend', params)
}
// 捐赠板块
export const thank = (params) => {
  return http.fetchGet('/goods/thank', params)
}

export const test = (params) => {
  return http.fetchGet('/api/chick/Test/test', params)
}



// WEBPACK FOOTER //
// ./src/api/index.js